import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, axiosInstance } from 'lib';

const TRANSPORT_MODE = process.env.REACT_APP_TRANSPORT_MODE;

const CREATE_USER =
    TRANSPORT_MODE !== "production"
        ? API.FIRM_ADD_USER
        : API.FIRM_ADD_USER;

const GET_COMPANY_USER_DETAILS = TRANSPORT_MODE !== "production"
    ? API.FIRM_USER_DETAILS
    : API.FIRM_USER_DETAILS;

const UPDATE_USER = TRANSPORT_MODE !== "production"
    ? API.UPDATE_FIRM_USER
    : API.UPDATE_FIRM_USER;

export const addroleCreate = createAsyncThunk(
    'add Role',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.ADD_ROLE, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const addUser = createAsyncThunk(
    'add User',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(CREATE_USER, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);


export const getUserDetail = (data = {}) => {
    return axiosInstance
        .post(
            GET_COMPANY_USER_DETAILS, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            if (error.name === 'TypeError') {
                // Handle network errors, such as a failed fetch request
                console.error('Network error:', error.message);
            } else {
                // Handle other errors, such as a bad response
                console.error('Error:', error.message);
            }
        });
};


export const editUser = createAsyncThunk(
    'edit User',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(UPDATE_USER, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

